import React, { useState, useEffect } from 'react';
import { Badge } from '@/components/ui/badge';
import { Wifi, WifiOff } from 'lucide-react';
import { supabase } from '@/integrations/supabase/client';

const RealtimeIndicator = () => {
  const [isConnected, setIsConnected] = useState(false);
  const [lastUpdate, setLastUpdate] = useState<Date | null>(null);

  useEffect(() => {
    // Monitor connection status
    const channel = supabase.channel('connection-status');
    
    channel.subscribe((status) => {
      console.log('Realtime status:', status);
      setIsConnected(status === 'SUBSCRIBED');
      if (status === 'SUBSCRIBED') {
        setLastUpdate(new Date());
      }
    });

    // Listen for any realtime changes to update the indicator
    const obligacionesChannel = supabase
      .channel('global-updates')
      .on('postgres_changes', { event: '*', schema: 'public' }, () => {
        setLastUpdate(new Date());
      })
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
      supabase.removeChannel(obligacionesChannel);
    };
  }, []);

  const formatLastUpdate = (date: Date) => {
    const now = new Date();
    const diff = now.getTime() - date.getTime();
    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);

    if (seconds < 60) return 'hace unos segundos';
    if (minutes < 60) return `hace ${minutes}m`;
    if (hours < 24) return `hace ${hours}h`;
    return date.toLocaleDateString();
  };

  return (
    <div className="fixed top-4 right-4 z-50">
      <Badge 
        variant={isConnected ? "default" : "destructive"}
        className="flex items-center gap-2 px-3 py-1"
      >
        {isConnected ? (
          <Wifi className="w-4 h-4" />
        ) : (
          <WifiOff className="w-4 h-4" />
        )}
        <span className="text-xs">
          {isConnected ? 'Conectado' : 'Desconectado'}
        </span>
        {lastUpdate && isConnected && (
          <span className="text-xs opacity-75">
            • {formatLastUpdate(lastUpdate)}
          </span>
        )}
      </Badge>
    </div>
  );
};

export default RealtimeIndicator;